export default "__VITE_ASSET__skU6OQsp__"